import Badge from '@material-ui/core/Badge'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import useStyles from './styles'
import { DetailedHTMLProps, FC, HTMLAttributes } from 'react'

type ActionButtonProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  Icon: FC<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>>
  badgeContent?: string | number
  className?: string
  variant?: string
}

const ActionButton = ({ Icon, badgeContent, className, variant, ...props }: ActionButtonProps) => {
  const classes: Record<string, string> = useStyles()

  return (
    <Badge
      className={classes.offset}
      classes={{
        badge: classes.badgeBg,
      }}
      invisible={!badgeContent}
      badgeContent={badgeContent}
    >
      <div className={classNames(classes.root, !!variant && classes[variant], className)} role="button" {...props}>
        <Icon className={classes.icon} aria-hidden="true" />
      </div>
    </Badge>
  )
}

export default ActionButton
